/** Created by azhou on 2019/2/15.*/
<template>
  <div>
    <div class="d-center">
      <span class="required-star" v-show="!order" :class="[required ? 'text-danger':'text-white','mr-small']">*</span>
      <div class="d-center required-left-text" v-show="leftText"><div class="form-left-text" :style="{width:width+'px'}" >{{leftText}}</div></div>
      <!--选择省市区，可反向赋值，可只显示选择省市、省市+多选区-->
      <div class="d-center-around" style="flex: 1;">
        <el-select v-model="provinceValue"
                   filterable
                   class="w-50" size="small"
                   @change="chooseProvince"
                   @visible-change="getProvinceArr"
                   placeholder="请选择省">
          <el-option v-for="item in provinceArr"
                     :key="item.id"
                     :label="item.title"
                     :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="cityValue" class="ml-1 w-50" v-if="secondMode"
                   @change="chooseCity" size="small"
                   @visible-change="getCityArr" filterable
                   placeholder="请选择市">
          <el-option v-for="item in cityArr"
                     :key="item.id"
                     :label="item.title"
                     :value="item.id">
          </el-option>
        </el-select>
        <el-select v-model="districtValue" class="ml-1 w-50" v-if="thirdMode && !mutiBlocks"
                   @visible-change="getDistrictArr" filterable size="small"
                   @change="chooseDistrict" placeholder="请选择区">
          <el-option v-for="item in districtArr"
                     :key="item.id"
                     :label="item.title"
                     :value="item.id">
          </el-option>
        </el-select>
      </div>
    </div>
    <!--多选区时显示所有的区-->
    <div v-show="mutiBlocks && districtArr.length>0" class="multi-blocks-container">
      <el-checkbox :indeterminate="isIndeterminate" v-model="checkAll" @change="handleCheckAllChange" class="selectAll">全选</el-checkbox>
      <el-checkbox-group v-model="districtValues" class="multi-blocks"
                         @change="chooseDistrict"
                         >
        <el-checkbox v-for="item in districtArr"
                     :key="item.id"
                     class="ml-0 mr-2 "
                     :label="item.id">{{item.title}}</el-checkbox>
      </el-checkbox-group>
    </div>
  </div>
</template>

<script>
  import {mapState,mapActions,mapMutations} from 'vuex'
  export default {
    name: 'SelectCity',
    props: {
      width: {
        type: Number,
        default:100
      },
      order: {
        type: Boolean,
        default: false
      },
      leftText: {
        type: String,
      },
      required: {
        type: Boolean,
        default: false
      },
      // disabled: {
      //   type: Boolean,
      //   default: false
      // },
      provinceId: {},
      cityId: {},
      districtId: {},
      districtIds: {
        type: Array,
        default() {
          return []
        }
      },
      mutiBlocks: {           //多选区模式
        type: Boolean,
        default: false
      },
      secondMode: {
        type: Boolean,
        default: true
      },
      thirdMode: {           //第三级区可选模式
        type: Boolean,
        default: true
      },
    },
    data () {
      return {
        provinceValue: '',                                         //组件内省Id
        cityValue: '',                                             //组件内市Id
        districtValue: '',                                         //组件内区Id
        districtValues: [],                                        //组件内多选区数组Ids
        provinceArr:[],                                            //省数组
        cityArr:[],                                                //省对应的市数组
        districtArr:[],                                            //市对应的区数组
        isIndeterminate: true,
        checkAll: false,
      }
    },
    computed: {
      /*省市区信息*/
      addressInfo () {
        let addressInfo = {
          province: this.provinceValue,
          city: this.cityValue,
          province_name: this.provinceValue ? this.provinceArr.filter(v => v.id === this.provinceValue)[0].title : '',
          city_name: this.cityValue ? this.cityArr.filter(v => v.id === this.cityValue)[0].title : '',
        }
        if (this.mutiBlocks) {        //多选区的情况
           if (this.districtValues.includes('')) { 
            this.districtValues = this.districtArr.map(v => v.id);
            let spliceArr = this.districtArr
            spliceArr.shift()
            addressInfo.district = spliceArr.map(t => {
              return {id:t.id,name:t.title}
            })
          } else {
            addressInfo.district = this.districtValues.map(v => {
              return {id:v,name:this.districtArr.filter(t => t.id === v)[0].title}
            });
          }
        } else {                      //单选区的情况
          addressInfo.district = this.districtValue;
          addressInfo.district_name = this.districtValue ? this.districtArr.filter(v => v.id === this.districtValue)[0].title : ''
        }
        return addressInfo;
      }
    },
    watch: {
      provinceId(newVal) {
          this.provinceValue =newVal?newVal:'';
        if (Number(newVal) > 0) {
          this.getProvinceArr(true);
        }else{
          //清空值
           this.provinceArr = [];
           this.cityArr = [];
           this.districtArr = [];
           console.log(this.provinceValue,'66')
        }
      },
      cityId(newVal) {
          this.cityValue = newVal||'';
        if (Number(newVal) > 0) {
          this.getCityArr(true);
        }
      },
      districtId(newVal) {
          this.districtValue = newVal||'';
        if (Number(newVal) > 0) {
          this.getDistrictArr(true);
        }
      },
      districtIds(newVal) {
        //只有两级时，选完市就调取接口获得所有的区信息
        if (this.mutiBlocks) this.getDistrictArr(true);
        this.districtValues = newVal;
      },
    },
    created() {
      //当prop传入的值没有发生变化时，组件被重新创建后需要再次赋值
      if (!this.provinceValue && this.provinceId) {
        this.provinceValue = this.provinceId;
        this.cityValue = this.cityId;
        this.districtValue = this.districtId;
        this.getProvinceArr(true);
        this.getCityArr(true);
        this.getDistrictArr(true);
      }
    },
    //组件销毁前，清空已获取的省市区信息
    beforeDestroy() {
      this.UPDATECITY([]);
      this.UPDATEDISTRICT([]);
    },
    methods: {
      ...mapActions(['getProvince']),
      ...mapMutations(['UPDATECITY','UPDATEDISTRICT']),
      /*获取省份数据*/
      getProvinceArr(flag) {
        if (flag && this.provinceArr.length <= 0) {
          this.getProvince({check: 1}).then(res => {
            this.provinceArr=res
          });
        }
      },
      /*获取某一省的市数组*/
      getCityArr (flag) {
        if (flag && this.provinceValue && this.cityArr.length <= 0) {
          this.getProvince({check: 2,id: this.provinceValue}).then(res => {
            this.cityArr=res
          });
        }
      },
      /*获取某一市的区数组*/
      getDistrictArr (flag) {
        if (flag && this.cityValue && this.districtArr.length <= 0) {
          this.getProvince({check: 3,id: this.cityValue}).then(res => {
            this.districtArr=res
          });
        }
      },
      /*选择省*/
      chooseProvince() {
        this.cityValue = '';
        this.districtValue = '';
        this.districtValues = [];
        this.UPDATECITY([]);                //清空cityArr数组
        this.cityArr = [];
        this.districtArr = [];
        this.UPDATEDISTRICT([]);            //清空districtArr数组
        this.$emit('getCityInfo',this.addressInfo);
      },
      /*选择市*/
      chooseCity() {
        this.districtValue = '';
        this.districtValues = [];
        this.districtArr = [];
        this.UPDATEDISTRICT([]);            //清空districtArr数组
        //只有两级时，选完市就调取接口获得所有的区信息
        if (this.mutiBlocks) this.getDistrictArr(true);
        this.$emit('getCityInfo',this.addressInfo);
      },
      //全选区
      handleCheckAllChange(val) {
        this.districtValues = val ? this.districtArr.map(v => v.id) : [];
        this.isIndeterminate = false;
        this.$emit('getCityInfo',this.addressInfo);
      },
      /*选择区*/
      chooseDistrict(value) {
        let checkedCount = value.length;
        this.checkAll = checkedCount === this.districtArr.length;
        this.isIndeterminate = checkedCount > 0 && checkedCount < this.districtArr.length;
        this.$emit('getCityInfo',this.addressInfo);
      }
    }
  }
</script>
<style lang="scss" scoped>
  .multi-blocks{
    margin-top: 4px;
    margin-bottom: 0;
    background: var(--smtc-color-back);
    display: flex;
    flex-wrap: wrap;
    padding: 6px 6px 0px 6px;
    border-radius: 4px;
  }
  .required-star{
    margin-left: 12px;
    margin-right: 3px;
  }
  .required-left-text{
    margin-right: 10px;
    text-align: right;
  }
  .multi-blocks-container{
    overflow: hidden;
  }
</style>
